import React, { useEffect } from 'react';
import { useProductStore } from '../store/productStore';

interface ProductImageProps {
  productId: string;
  className?: string;
  alt?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
  fallback?: React.ReactNode;
}

export const ProductImage: React.FC<ProductImageProps> = ({
  productId,
  className = '',
  alt = 'Product Image',
  loading = 'lazy',
  fetchPriority,
  fallback
}) => {
  const imagesMap = useProductStore((state) => state.imagesMap);
  const fetchProductImage = useProductStore((state) => state.fetchProductImage);

  const imageObj = imagesMap[productId];

  useEffect(() => {
    if (!imageObj) {
      fetchProductImage(productId);
    }
  }, [productId, imageObj, fetchProductImage]);

  // Loading skeleton
  if (!imageObj) {
    return <div className={`animate-pulse bg-slate-100 ${className}`} />;
  }

  const imageUrl = imageObj.imageUrl;

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={alt}
        loading={loading}
        fetchPriority={fetchPriority}
        className={className}
      />
    );
  }

  // Fallback if no image URL exists
  return (
    fallback || (
      <div className={`flex flex-col items-center justify-center bg-slate-100 text-slate-500 ${className}`}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mb-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <span className="text-[7px] font-bold tracking-wider uppercase leading-none">No Image</span>
      </div>
    )
  );
};
